export default __webpack_public_path__ + "static/media/return-3.bb32fbbf.svg";